// Pro.jsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Seo from "../seo/Seo";
import Breadcrumbs from "./Breadcrumbs";
import LocalImage from "./LocalImage";
import { softwareApplicationJsonLd } from "../seo/site";
import "./Pro.css";
import "aos/dist/aos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { useLocationContext } from "./LocationInterface";

const Pro = () => {
  const { currencySymbol, isIndia } = useLocationContext();

  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div>
      <Seo
        title="Connct Pro – Multiple Profiles, Analytics and Custom Cards | Connct"
        description="Unlock multiple profiles, custom icons, a media gallery and analytics on your Connct digital business card. Pro is $11.97 a year, or ₹999 a year in India."
        path="/upgrade-to-pro"
        extraGraph={[softwareApplicationJsonLd]}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Pro", path: "/upgrade-to-pro" },
        ]}
      />

      <div class="wrapper">
        <div class="container section" style={{ marginTop: "140px" }}>
          <div className="page-header">
            <Breadcrumbs
              items={[
                { name: "Home", path: "/" },
                { name: "Pro", path: "/upgrade-to-pro" },
              ]}
            />
            <h1 className="h2">
              Unveil <b>THE ULTIMATE BUSINESS CARD</b> with Connct PRO
            </h1>
            <br />
            <br />
            <h5 style={{ fontSize: "34px" }}>
              Switch to <b> Business Profile </b>to unlock advanced features
            </h5>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="card-container">
          {/* <div className="card-wrapper" data-aos="fade-up"> */}
          <div
            className="card"
            style={{
              // marginLeft: "200px",
              background:
                "linear-gradient(131deg, #046BD2 1.87%, #6EB4FF 73.23%, rgba(245, 250, 255, 0.73) 99.24%, rgba(245, 250, 255, 0.73) 99.25%)",
              border: "1px solid #046BD2",
              borderRadius: "10px",
              padding: "20px",
              boxSizing: "border-box",
              height: "627px",
            }}
          >
            <div>
              <h2
                className="c-primary"
                style={{ color: "#F5DB7D", fontWeight: "bold" }}
              >
                Standard <br />
                Plan
              </h2>
              <ul className="feature-list" style={{ color: "white" }}>
                <li></li>
                <li></li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Add Contact Details
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Social Media Links
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>One-click contact
                  button
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Contact form
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Add any Link
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Advanced Analytics
                </li>
              </ul>
            </div>

            <Link to="/download-connct" className="choose-plan">
              <div
                style={{
                  display: "inline-block",
                  // marginLeft: "10px",
                  // marginTop: "45px",
                }}
              >
                <button
                  className="choose-plan-button"
                  style={{ fontWeight: "bold" }}
                >
                  Choose Plan
                </button>
              </div>
            </Link>
          </div>
          {/* </div> */}
          {/* <div className="card-wrapper" data-aos="fade-up" data-aos-delay="100"> */}
          <div
            className="card"
            style={{
              background:
                "linear-gradient(43deg, #D0E7FF 4.34%, rgba(235, 235, 235, 0.86) 46.88%, rgba(255, 255, 255, 0.00) 100%)",
              borderColor: "skyblue",
              borderWidth: "2px",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                backgroundColor: "#F46363",
                color: "#F5DB7D",
                padding: "3px 10px",
                borderRadius: "15px",
                fontSize: "12px",
              }}
            >
              Most Popular
            </div>
            <div>
              <h2 className="c-primary">
                <span
                  style={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    color: "#4996B8",
                  }}
                >
                  Pro
                </span>{" "}
                <br />
                <b style={{ fontSize: "32px", color: "#4996B8" }}>
                  <span
                    style={{
                      fontSize: "42px",
                      fontWeight: "bold",
                      verticalAlign: "middle",
                    }}
                  >
                    {currencySymbol}
                  </span>
                  <span style={{ verticalAlign: "middle" }}>
                    {isIndia ? "999" : "11.97"}
                  </span>
                </b>
                <span
                  style={{
                    fontSize: "16px",
                    color: "#4996B8",
                    fontWeight: "500",
                  }}
                >
                  /Year
                </span>
              </h2>
              <ul className="feature-list">
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Add Contact Details
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Social Media Links
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>One-click contact
                  button
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Contact form
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Other links
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Custom Icons & Title
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Advanced Analytics
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Multiple Profiles
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Photos, Videos & Pdfs
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Personalized Icons
                </li>
                <li style={{ fontSize: "17px" }}>
                  <i className="fas fa-check-circle"></i>Add Custom Links
                </li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
            <Link to="/download-connct" className="choose-plan">
              <button className="choose-plan-button2">Choose Plan</button>
            </Link>
          </div>
          {/* </div> */}
        </div>
      </div>
      <br />
      <div class="container section">
        <section className="upgrade-plan">
          <div className="row section">
            <div className="col-md-6 align-center" data-aos="fade-up">
              <div className="text-left">
                <div className="col-12" data-aos="fade-up">
                  <h3 className="fw-bold mb-3 c-primary">Advanced Analytics</h3>
                </div>
                <h4 className="fw-normal">
                  Track all the activity your potential customer performs with
                  Connct’s advanced analytics.{" "}
                </h4>
                <p style={{ fontSize: "17px" }}>
                  You can measure ROI by calculating
                </p>
                <ul className="circle-bullet no-bullets">
                  <li data-aos="fade-up">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{
                        paddingRight: "10px",
                        color: "#FAAD3D",
                        fontSize: "20px",
                      }}
                    />
                    The number of profile visits
                  </li>
                  <li data-aos="fade-up">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{
                        paddingRight: "10px",
                        color: "#FAAD3D",
                        fontSize: "20px",
                      }}
                    />
                    Total link taps
                  </li>
                  <li data-aos="fade-up">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{
                        paddingRight: "10px",
                        color: "#FAAD3D",
                        fontSize: "20px",
                      }}
                    />
                    Number of connections
                  </li>
                  <li data-aos="fade-up">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{
                        paddingRight: "10px",
                        color: "#FAAD3D",
                        fontSize: "20px",
                      }}
                    />
                    Total contacts saved
                  </li>
                  <li data-aos="fade-up">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{
                        paddingRight: "10px",
                        color: "#FAAD3D",
                        fontSize: "20px",
                      }}
                    />
                    Link Engagement
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 text-center" data-aos="fade-up">
              <LocalImage
                className="img-fluid image-lg mx-auto d-block"
                src={require("../assets/images/analytics.png")}
                webp={require("../assets/images/analytics.webp")}
                alt="Advanced Analytics"
                width={900}
                height={900}
                style={{ aspectRatio: "1 / 1" }}
              />
            </div>
          </div>

          <div className="row section">
            <div className="col-12">
              <h3 className="fw-bold mt-4" style={{ fontWeight: "800" }}>
                Unlimited Themes
              </h3>
              <p
                className="small"
                data-aos="fade-up"
                style={{ fontSize: "18px" }}
              >
                Choose between an array of attractive themes to stand out in the
                crowd.
              </p>
            </div>
            <div
              className="col-md-12 my-1"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <LocalImage
                className="img-fluid mx-auto d-block image-lg"
                src={require("../assets/images/themes.png")}
                webp={require("../assets/images/themes.webp")}
                alt="Unlimited Themes"
                width={742}
                height={706}
                style={{ width: "40%", height: "auto", aspectRatio: "742 / 706" }}
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Pro;
